/*-----------------------------------------------------------------
- Export
-----------------------------------------------------------------*/
import { install, configs } from './src/index';

export { configs };
export default { install };